<section class="applecare-enterprise-section ptb-100" style="margin-top: 100px;">
    <div class="container text-center">
        <img src="assets/images/applecare.png" alt="AppleCare for Enterprise" class="img-fluid" style="max-width: 100px; margin-bottom: 20px;">
        <h1>AppleCare for Enterprise</h1>
    </div>
</section>
<section class="background-image-section applecare-banner">
    <div class="container text-center text-white">
       <!--  <h2>Comprehensive Coverage for Your Enterprise</h2>
        <p>Experience unparalleled support and service with AppleCare for Enterprise, ensuring your business runs smoothly and efficiently.</p> -->
    </div>
</section>

<section class="support-section ptb-100">
    <div class="container text-center">
        <h2>Priority onsite service and 24/7 support help keep your end users up and running</h2>
        <div class="row justify-content-center">
            <div class="col-lg-4 col-sm-6">
                <div class="support-feature">
                    <i class='bx bx-headphone' style="font-size: 50px; color: #b2231c; margin-bottom: 10px;"></i>
                    <p>24/7 technical support for end users</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6">
                <div class="support-feature">
                    <i class='bx bx-wrench' style="font-size: 50px; color: #b2231c; margin-bottom: 10px;"></i>
                    <p>Onsite service for 2, 3 or 4 years</p>
                </div>
            </div>
        </div>
    </div>
</section>

<hr style="border-top: 1px solid #646161; margin: 0 100px;">
<section class="coverage-section ptb-100">
    <div class="container text-center">
        <h1 style="font-size: 4rem; font-weight: bold;">Coverage for every Mac, Apple Studio Display, iPhone and iPad.</h1>
        <p style="font-size: 21px;">AppleCare for Enterprise includes flexible service options, priority onsite services and as fast as next-business-day device repair or replacement.</p>
    </div>
</section>

<section class="background-image-section">
    <div class="container text-center text-white">
        <div class="row">
            <div class="col-md-6 mb-4">
                <img src="assets/images/applecareA.png" alt="AppleCare Image 1" class="img-fluid rounded">
            </div>
            <div class="col-md-6 mb-4">
                <img src="assets/images/applecareB.png" alt="AppleCare Image 2" class="img-fluid rounded">
            </div>
        </div>
    </div>
</section>

<hr style="border-top: 1px solid #646161;" class="mt-100">

<section class="support-end-users-section ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <h2 style="font-size: 40px; font-weight: bold;">Support for end users</h2>
            </div>
            <div class="col-lg-6">
                <p style="font-size: 21px;">AppleCare for Enterprise can help reduce the load on your internal help desk by providing unlimited technical support for your end users over the phone, 24/7. Apple will provide technical support for Apple hardware and operating systems; Apple apps such as Keynote, Pages and Numbers; and personal accounts or settings.</p>
            </div>
        </div>
    </div>
</section>
<hr style="border-top: 1px solid #646161;">
<section class="it-support-section ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <h2 style="font-size: 40px; font-weight: bold;">IT department support</h2>
            </div>
            <div class="col-lg-6">
                <p style="font-size: 21px;">
                    AppleCare for Enterprise includes AppleCare Help Desk Support which provides unlimited telephone technical support for hardware and software diagnosis and troubleshooting and issue isolation for Apple-based solutions. This direct access to our Business and Education advisors includes graphical user interface-level assistance with macOS Server network configuration and server administration. You can even get help for Apple Business Manager or Apple School Manager when you call.
                </p>
                <p style="font-size: 21px;">
                    For more complex issues, AppleCare for Enterprise gives you an incident of IT department-level support each year. You'll get help with complex deployment and integration scenarios, including MDM and Active Directory.
                </p>
                <p style="font-size: 21px;">
                    You can also purchase additional IT department support through an AppleCare OS Support agreement for an additional fee.
                </p>
                <p style="font-size: 21px;">
                    Whether you have occasional questions or you need assistance on a regular basis, Apple has flexible support plans to fit your requirements.
                </p>
            </div>
        </div>
    </div>
</section>
<hr style="border-top: 1px solid #646161;">

<section class="applecare-enterprise-section ptb-100 text-center">
    <div class="container">
        <h2 style="font-size: 40px; font-weight: bold;">Get AppleCare for Enterprise now.</h2>
        <p style="font-size: 21px;">
            AppleCare for Enterprise is available in volume-based price tiers starting from 1,000 and 5,000 covered devices. Contact Apple, an Apple Authorised Reseller or an Authorised Carrier Partner to receive a quote for AppleCare for Enterprise.
        </p>
       <!--  <p>For more details</p>
        <a href="/contact" class="download-btn">Contact us</a>  -->
        <a href="/contact" style="font-size: 21px; color: #0070c9; text-decoration: underline; display: block; margin-top: 20px;">For more details and contact us ›</a>
        <!-- <a href="#" style="font-size: 21px; color: #0070c9; text-decoration: underline;">Read terms and conditions ›</a> -->
    </div>
</section>
